import { format } from "date-fns";
import { ColumnFilter } from "./ColumnFilter";
import { useSelector } from "react-redux";
import {diapasonFilter, selectsFilter, dateRangeFilter} from "./functions";
import { usd } from "../../dataFunctions";

/*function diapasonFilter(rows, columnIds, filterValue) {
  return filterValue.length === 0 ? rows : rows.filter(row => {
    if (Number(row.original[columnIds]) >= filterValue[0]
      && Number(row.original[columnIds]) <= filterValue[1]) {
      return row;
    }
  });
}

function selectsFilter(rows, columnIds, filterValue) {
  return filterValue.length === 0 ? rows : rows.filter(row => {
    if (filterValue.indexOf(row.original[columnIds]) > -1) return row;
  });
}

function dateRangeFilter(rows, columnIds, filterValue) {
  return filterValue.length === 0 ? rows : rows.filter(row => {
    if (new Date(row.original[columnIds]).getTime() >= new Date(filterValue[0]).getTime()
      && new Date(row.original[columnIds]).getTime() <= new Date(filterValue[1]).getTime()) {
      return row;
    }
  });
}*/

/*function usd(_usd, _precision) {
  //return val ? val.toFixed(precision) : "";
  return _usd
    ? _usd.toLocaleString("en-US", { maximumFractionDigits: _precision })
    : "";
}*/

/*export const PortfolioColumns = (_rData) => {
  //const rData = useSelector((state) => state.portfolio.rData);

  const _tblColumns = [
    { accessor: "id", Header: "Asset Id", disableFilters: true, width: 60 },
    {
      accessor: "Datetime",
      Header: "Datetime",
      disableFilters: true,
      width: 90,
    },
    { accessor: "Wallet", Header: "Wallet", width: 90 },
    { accessor: "Blockchain", Header: "Blockchain", width: 120 },
    { accessor: "Platform", Header: "Platform", width: 100 },
    //{ accessor: "Vault", Header: "Vault", width: 140 },
    {
      //accessor: "Vault",
      accessor: acs => `${acs.Vault} ${acs.LpTokensUsd}`,
      Header: "Vault",
      width: 140,
      // Cell: (props) => {
      //   const a = _rData.filter((el) => el.id == props.row.id);
      //   console.log(
      //     "Test vault =",
      //     props.row.id,
      //     props.value,
      //     a.LpTokensUsd,
      //     a,
      //     props
      //   );
      //   return (
      //     <div className="cellVault">
      //       <span className="cellVaultTitle">{props.value}</span>
      //       <span className="cellVaultTokRates">{a[0]?.LpTokensUsd}</span>
      //     </div>
      //   );
      // },
    },
    {
      accessor: "Balance",
      Header: "Balance",
      width: 110,
      Cell: (props) => usd(props.value, 6),
      // style: {
      //   textAlign: "right",
      // },
    },
    { accessor: "LpTokensUsd", Header: "LpTokPrc$", width: 120 },
    {
      accessor: "BalanceUsd",
      Header: "Balance$",
      width: 110,
      Cell: (props) => usd(props.value, 2),
    },
    {
      accessor: "Reward",
      Header: "Rewards",
      width: 110,
      Cell: (props) => usd(props.value, 6),
    },
    { accessor: "RewardToken", Header: "RwdTokens", width: 130 },
    { accessor: "RewardTokensUsd", Header: "RwdTokPrc$", width: 120 },
    //{ accessor: "RewardUsd", Header: "RewardUsd", width: 120 },
    {
      accessor: "RewardUsd",
      Header: "Reward$",
      width: 110,
      Cell: (props) => usd(props.value, 4),
    },
    {
      accessor: "TotalUsd",
      Header: "Total$",
      width: 90,
      Cell: (props) => usd(props.value, 2),
    },
  ];

  return _tblColumns;
};*/

export const tblColumns = [
  { accessor: "Wallet", Header: "Wallet", width: 160, filterType: 'select', filter: selectsFilter },
  { accessor: "id", Header: "Asset Id", disableFilters: true, width: 60 },
  { accessor: "Blockchain", Header: "Blockchain", width: 140, filterType: 'select', filter: selectsFilter },
  { accessor: "Platform", Header: "Platform", width: 140, filterType: 'select', filter: selectsFilter },
  {
    //accessor: "Vault",
    //accessor: obj => `${obj.Vault} ${obj.LpTokensUsd}`,
    accessor: (obj) => (
      <div className="cellVault">
        <span className="cellVaultTitle">{obj.Vault}</span>
        <span className="cellVaultTokRates">{obj.LpTokensUsd}</span>
      </div>
    ),
    Header: "Vault",
    width: 140,
  },
  { accessor: "Uses", Header: "Uses", width: 120, filterType: 'select', filter: selectsFilter },
  {
    accessor: "TotalUsd",
    Header: "Total$",
    width: 90,
    Cell: (props) => usd(props.value, 2),
  },
  {
    accessor: "Balance",
    Header: "Balance",
    //width: 110,
    width: 180, filterType: 'slider', filter: diapasonFilter,
    Cell: (props) => usd(props.value, 8),//4
    /*style: {
      textAlign: "right",
    },*/
  },
  //{ accessor: "LpTokensUsd", Header: "LpTokPrc$", width: 120 },
  {
    accessor: "BalanceUsd",
    Header: "Balance$",
    width: 110,
    Cell: (props) => usd(props.value, 2),
  },
  {
    accessor: "Reward",
    Header: "Rewards",
    //width: 110,
    width: 160, filterType: 'diapason', filter: diapasonFilter,
    Cell: (props) => usd(props.value, 6),
  },
  { //accessor: "RewardToken",
  accessor: (obj) => (
    <div className="cellVault">
      <span className="cellVaultTitle">{obj.RewardToken?.replace(/,/g, ", ")}</span>
      <span className="cellVaultTokRates">{obj.RewardTokensUsd}</span>
    </div>
  ),
  Header: "RwdTokens", width: 130 },
  //{ accessor: "RewardTokensUsd", Header: "RwdTokPrc$", width: 120 },
  //{ accessor: "RewardUsd", Header: "RewardUsd", width: 120 },
  {
    accessor: "RewardUsd",
    Header: "Reward$",
    width: 110,
    Cell: (props) => usd(props.value, 4),
  },
  { accessor: "Datetime", Header: "Datetime",  width: 244, filterType: 'date', filter: dateRangeFilter },
];

export const COLUMNS = [
  {
    Header: "Id",
    Footer: "Id",
    accessor: "id",
    disableFilters: true,
    width: 30,
  },

  {
    Header: "First Name",
    Footer: "First Name",
    accessor: "first_name",
  },

  {
    Header: "Last Name",
    Footer: "Last Name",
    accessor: "last_name",
  },

  {
    Header: "Date of Birth",
    Footer: "Date of Birth",
    accessor: "date_of_birth",
    Cell: ({ value }) => {
      return format(new Date(value), "dd/MM/yyyy");
    },
  },

  {
    Header: "Country",
    Footer: "Country",
    accessor: "country",
  },

  {
    Header: "Phone",
    Footer: "Phone",
    accessor: "phone",
  },
];

export const GROUPED_COLUMNS = [
  {
    Header: "Id",
    Footer: "Id",
    accessor: "id",
  },
  {
    Header: "Name",
    Footer: "Name",
    columns: [
      {
        Header: "First Name",
        Footer: "First Name",
        accessor: "first_name",
      },

      {
        Header: "Last Name",
        Footer: "Last Name",
        accessor: "last_name",
      },
    ],
  },
  {
    Header: "Info",
    Footer: "Info",
    columns: [
      {
        Header: "Date of Birth",
        Footer: "Date of Birth",
        accessor: "date_of_birth",
      },

      {
        Header: "Country",
        Footer: "Country",
        accessor: "country",
      },

      {
        Header: "Phone",
        Footer: "Phone",
        accessor: "phone",
      },
    ],
  },
];
